export default "__VITE_ASSET__2lz8K0dm__"